import React from 'react';

var Plus = function Plus(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    d: "M11 11V5a1 1 0 0 1 2 0v6h6a1 1 0 0 1 0 2h-6v6a1 1 0 0 1-2 0v-6H5a1 1 0 0 1 0-2h6z",
    fill: "currentColor",
    fillRule: "nonzero"
  }));
};

Plus.defaultProps = {
  role: "img",
  viewBox: "0 0 24 24"
};
import iconHandler from './hoc';
export { Plus as icon };
export default iconHandler(Plus);


//////////////////
// WEBPACK FOOTER
// ./~/@jsluna/icons/dist/Plus.js
// module id = 619
// module chunks = 0